// 按钮对下对应边线及圆角
export const button = {
    large: 1,
    medium: 1,
    small: 1,
    mini: 1,
    mini_s: 0.5,
    mini_xs: 0.5
};
